import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatDistanceToNow } from "date-fns";

const VehicleAboveKmDetailModal = ({ show, onHide, data }) => {
  if (!data) return null;
  const formatDate = (date) => {
    if (!date) return "N/A";
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Ticket Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Date:</strong> {formatDate(data.date)}
        </p>

        <p>
          <strong>Number Plate:</strong> {data.numberplate}
        </p>
        <p>
          <strong>Driver:</strong> {data.drivers}
        </p>
        <p>
          <strong>Clients:</strong> {data.clients}
        </p>
        <p>
          <strong>Daily Km:</strong> {data.dailyKm}
        </p>
        <p>
          <strong>Hub:</strong> {data.hub}
        </p>
        <p>
          <strong>Company:</strong> {data.company}
        </p>
        <p>
          <strong>Leasing Partner:</strong> {data.leasing_partner}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VehicleAboveKmDetailModal;
